import { ActionType } from "../../../../react-core/Flux/ActionType";
import { UserPageColumnSettingClient } from "../../../../Wrap/Api/User/UserPageColumnSetting";
import { TransactionInvestmentsColumns } from "../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionInvestmentsColumns";
import { defaultTableColEditor } from "../Resource/Content";
import { TableColSettingsDispatcher, TableColSettingsStore } from "../Store/Variable";

export class TableColSettingsAction {
    public static get(key: string) {
        const client = new UserPageColumnSettingClient();
        client
            .get()
            .onSuccess((settings) => {
                if (settings && settings.TransactionInvestmentsColumnSettings) {
                    const transactionInvestment = settings.TransactionInvestmentsColumnSettings.filter(
                        (x) => x.Column != TransactionInvestmentsColumns.FxCost
                    );

                    settings.TransactionInvestmentsColumnSettings = transactionInvestment;
                }
                TableColSettingsDispatcher.dispatch({ actionType: ActionType.Success, payload: settings || {} });
            })
            .onError((error) => {
                TableColSettingsDispatcher.dispatch({ actionType: ActionType.Error, payload: error });
            });
    }

    public static post(settings, key?: string) {
        const client = new UserPageColumnSettingClient();
        let _data = TableColSettingsStore.getData();
        if (key) {
            _data[key] = settings;
        } else {
            _data = settings;
        }

        client
            .post(_data)
            .onSuccess((validate) => {
                TableColSettingsDispatcher.dispatch({ actionType: ActionType.Success, payload: _data });
            })
            .onError((error) => {
                TableColSettingsDispatcher.dispatch({ actionType: ActionType.Error, payload: error });
            });
    }
}
